import script from "./MenuCard.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuCard.vue?vue&type=script&setup=true&lang=js"

import "./MenuCard.vue?vue&type=style&index=0&id=27ca36ec&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27ca36ec"]])

export default __exports__